/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import menuOverflow32 from '@ba-ui-toolkit/ba-graphics/dist/icons/overflow-menu--horizontal_32.svg';
import ContextMenuIcon from 'components/contextMenu/ContextMenuIcon';

import StringResources from 'nls/StringResources';

@observer
class SidePaneHeader extends Component {

	render() {
		const { cardListVM } = this.props;

		const isEditMode = cardListVM.isEditMode();

		const leftSection = this.renderLeftSection(isEditMode);
		const title = this.renderTitle(isEditMode);
		const rightSection = this.renderRightSection(isEditMode);

		return (
			<div className="sidePane__header">
				{leftSection}
				{title}
				{rightSection}
			</div>
		);
	}

	renderLeftSection(isEditMode) {
		if (isEditMode) {
			return (
				<div
					className="sidePane__header__leftButton"
					onClick={this.cancelEditMode}
				>{StringResources.get('cancel_multiselect')}</div>
			);
		} else {
			return undefined;
		}
	}

	renderRightSection(isEditMode) {
		const {
			cardListVM
		} = this.props;

		const showContextMenu = cardListVM.shouldShowContextMenu();

		if (isEditMode) {
			return (
				<ContextMenuIcon
					iconId={menuOverflow32.id}
					items={showContextMenu ? this.getContextMenuItems() : undefined}
					onChange={this.props.onContextMenuChange}
					onToggle={this.onContextMenuToggle}
					thumbnails={cardListVM.thumbnails}
				/>
			);
		} else {
			return undefined;
		}
	}

	renderTitle(isEditMode) {
		const title = !isEditMode && StringResources.get('cardListTitle');
		return (
			<div className="sidePane__header__title">{title}</div>
		);
	}

	// Events

	onContextMenuToggle = (toggle) => {
		const { cardListVM } = this.props;
		const { exploreVM } = cardListVM;
		const ids = toggle ? exploreVM.selectedCards.items : null;

		cardListVM.showContextMenu(ids);
	}

	// Internal

	cancelEditMode = () => {
		const { cardListVM } = this.props;
		cardListVM.clearSelection();
		cardListVM.clearContextMenu();
	}

	getContextMenuItems(cards) {
		return this.props.cardListVM.getContextMenuItems(cards);
	}
}

SidePaneHeader.propTypes = {
	cardListVM: PropTypes.object.isRequired,
	onContextMenuChange: PropTypes.func
};

SidePaneHeader.defaultProps = {
	onContextMenuChange: () => {}
};

export default SidePaneHeader;



// WEBPACK FOOTER //
// ./src/js/components/cards/SidePaneHeader.js